import { render, staticRenderFns } from "./InspectionButton.vue?vue&type=template&id=182475ee&scoped=true&"
import script from "./InspectionButton.vue?vue&type=script&lang=js&"
export * from "./InspectionButton.vue?vue&type=script&lang=js&"
import style0 from "./InspectionButton.vue?vue&type=style&index=0&id=182475ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182475ee",
  null
  
)

export default component.exports